import { cva } from "class-variance-authority"
import Actions from "./DialogActions.svelte"
import Close from "./DialogClose.svelte"
import Content from "./DialogContent.svelte"
import Description from "./DialogDescription.svelte"
import Overlay from "./DialogOverlay.svelte"
import Portal from "./DialogPortal.svelte"
import Root from "./DialogRoot.svelte"
import Title from "./DialogTitle.svelte"
import Trigger from "./DialogTrigger.svelte"

export type { DialogRootProps } from "./DialogRoot.svelte"

export const Dialog = {
  Content,
  Portal,
  Root,
  Trigger,
  Description,
  Close,
  Title,
  Overlay,
  Actions,
}

export const titleVariants = cva(
  "title flex flex-row items-center justify-between font-xlarge-650",
  {
    variants: {
      variant: {
        confirmation: "text-general-primary-text",
        modal: `gap-2 rounded-t-md text-general-primary-text`,
        warning: "",
      },
    },
    defaultVariants: {
      variant: "confirmation",
    },
  }
)

export const contentVariants = cva(
  "absolute-center-y fixed inset-x-0 z-40 mx-auto max-h-[90vh] w-[90vw] max-w-xl overflow-y-auto overflow-x-hidden rounded-lg shadow-bottom-150 data-[state=open]:animate-show",
  {
    variants: {
      variant: {
        confirmation: "border border-general-neutral-01 bg-general-surface-01",
        modal:
          "border border-general-neutral-01 bg-general-surface-01 focus-visible:outline-none focus-visible:ring-2",
        warning: "border border-alert-pending bg-alert-order-working",
      },
      // V2 will shift away from padding between elements and prefer margin
      spacing: {
        standard: "space-y-4 p-6 last:[&>*]:mt-6",
        legacy: "[&>*:first-child]:pb-0 [&>*]:p-3",
        none: "",
      },
    },
    defaultVariants: {
      variant: "confirmation",
    },
    compoundVariants: [
      {
        spacing: "legacy",
        variant: "modal",
        class: "p-5",
      },
      {
        spacing: "legacy",
        variant: "confirmation",
        class: "px-4 py-2",
      },
    ],
  }
)
